import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const EmailForm = ({ email, onEmailChange, error, onValidate }) => {
  const [touched, setTouched] = useState(false);

  const handleBlur = () => {
    setTouched(true);
    onValidate();
  };

  const handleChange = (e) => {
    onEmailChange(e?.target?.value);
    if (touched) {
      onValidate();
    }
  };

  return (
    <div className="w-full">
      <Input
        type="email"
        label="Email Address"
        placeholder="your.email@example.com"
        value={email}
        onChange={handleChange}
        onBlur={handleBlur}
        error={touched ? error : ''}
        required
        className="mb-4"
        description="We'll send your results here. No spam."
      />
      
      <div className="flex items-start gap-3 mt-4 p-4 bg-brand-black rounded-md border border-brand-slate">
        <Icon name="Shield" size={20} color="#C9A227" className="flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-brand-white font-bold mb-1 uppercase tracking-wide">
            100% Confidential
          </p>
          <p className="text-xs text-brand-steel leading-relaxed">
            Your data is encrypted. Never shared. Period.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmailForm;